// @ts-nocheck
import { toastTypes } from '../../enums';
import { createOAuthIntegrationStore } from './_shared';

export default createOAuthIntegrationStore({
  partnerKey: 'Mailchimp',
  defaultConfigs: { enabled: false },
  toastKeys: { update: toastTypes.mailChimpUpdateConfigs, tokens: toastTypes.mailChimpGetTokens },
  successMessages: { tokens: 'Mailchimp integration successful.' },
});
